import { ArrowLeft } from "lucide-react";
import { Link, useSearchParams } from "react-router-dom";

import { Seo } from "@/components/seo";
import { Button } from "@/components/ui/button";
import { ResetPasswordForm } from "@/features/reset-password/components/reset-password.form";

export function ForgotPassword() {
  const [searchParams] = useSearchParams();
  const sent = searchParams.get("sent");

  if (sent) {
    return (
      <div className="px-4 sm:px-6">
        <Seo title="Forgot Password" />

        <p className="text-lg font-medium text-foreground">
          Reset Request Sent
        </p>
        <p className="text-base font-normal text-muted">
          Please follow the instructions contained within the recovery email.
        </p>

        <div className="my-8 sm:my-11 sm:mt-8">
          <Button asChild>
            <Link className="w-full" to="/sign-in">
              <ArrowLeft className="mr-2 h-4 w-4" />
              Back to Sign In
            </Link>
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="px-4 sm:px-6">
      <Seo title="Forgot Password" />

      <Button variant="ghost" asChild>
        <Link to="/sign-in" className="mb-6">
          <ArrowLeft className="mr-2 h-4 w-4" />
          Back to Login
        </Link>
      </Button>
      <p className="text-lg font-medium text-foreground">Reset Password</p>
      <p className="mb-6 text-base font-normal text-muted">
        Forgotten your login details? Enter your email, and if an account
        exists, a reset link will be sent to that address.
      </p>

      <div className="mb-8 sm:mb-11">
        <ResetPasswordForm />
      </div>
    </div>
  );
}
